<template>
  <a-dropdown v-if="visible" :trigger="['click']" placement="bottomRight">
    <span class="audit-pending-trigger">
      <a-badge :count="total" :overflow-count="99" :offset="[2, -2]">
        <a-icon type="bell" class="audit-pending-icon" />
      </a-badge>
    </span>
    <a-menu slot="overlay" @click="onMenuClick">
      <a-menu-item v-if="showRedeem" key="redeem">
        兑换待审核
        <a-badge v-if="redeem > 0" :count="redeem" :overflow-count="99" style="margin-left: 8px" />
      </a-menu-item>
      <a-menu-item v-if="showWithdraw" key="withdraw">
        提现待审核
        <a-badge v-if="withdraw > 0" :count="withdraw" :overflow-count="99" style="margin-left: 8px" />
      </a-menu-item>
      <a-menu-item v-if="showCs" key="cs">
        客服待处理
        <a-badge v-if="csUnread > 0" :count="csUnread" :overflow-count="99" style="margin-left: 8px" />
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { navigateToCsWorkbench } from '@/utils/csEmbed'

export default {
  name: 'AuditPendingNotice',
  computed: {
    ...mapGetters([
      'auditRedeemPending',
      'auditWithdrawPending',
      'csUnreadTotal',
      'permissions'
    ]),
    redeem() {
      return Number(this.auditRedeemPending) || 0
    },
    withdraw() {
      return Number(this.auditWithdrawPending) || 0
    },
    csUnread() {
      return Number(this.csUnreadTotal) || 0
    },
    // 角标只累计当前账号有权限的菜单，避免无兑换/提现权限时仍把待审数算进「客服待处理」
    total() {
      let n = 0
      if (this.showRedeem) n += this.redeem
      if (this.showWithdraw) n += this.withdraw
      if (this.showCs) n += this.csUnread
      return n
    },
    showRedeem() {
      return this.hasPerm('giftcard:redeem:list')
    },
    showWithdraw() {
      return this.hasPerm('giftcard:withdraw:list')
    },
    showCs() {
      return this.hasPerm('customer:workbench:view')
    },
    visible() {
      return this.showRedeem || this.showWithdraw || this.showCs
    }
  },
  methods: {
    hasPerm(perm) {
      const perms = this.permissions || []
      return perms.includes(perm) || perms.includes('*:*:*')
    },
    onMenuClick({ key }) {
      if (key === 'redeem') {
        this.$router.push({ path: '/giftcard/redeem' })
      } else if (key === 'withdraw') {
        this.$router.push({ path: '/giftcard/withdraw' })
      } else if (key === 'cs') {
        navigateToCsWorkbench(this.$router, this.$store)
      }
    }
  }
}
</script>

<style scoped>
.audit-pending-trigger {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 0 8px;
}

.audit-pending-icon {
  font-size: 18px;
}
</style>
